import { Box } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

interface INotificationBox {
  color: string;
}
export const NotificationBox = styled(Box)<INotificationBox>(({ color }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: 40,
  borderRadius: 8,
  borderLeft: `3px solid ${color}`,
  padding: '20px 24px',
  gap: '20px',
  background: alpha(color, 0.06),
}));

export const LabelBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 15,
}));

export const DeadlineTextBox = styled(Box)<INotificationBox>(({ color }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  p: {
    color,
    fontSize: 18,
  },
  '.bold': {
    fontWeight: 600,
  },
}));

export const ProgressBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
}));

export const ProgressLabel = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: 14,
  fontWeight: 500,
}));

export const ProgressBar = styled(Box)(({ theme }) => ({
  width: '100%',
  height: 12,
  borderRadius: 6,
  background: theme.palette.common.white,
  overflow: 'hidden',
}));

export const ProgressFill = styled(Box)<INotificationBox>(({ color }) => ({
  height: '100%',
  background: color,
}));
